import { Experiment, ExperimentClient, Variant } from "@amplitude/experiment-js-client";
import { Context } from "@nuxt/types";
import Vue from "vue";

import ExperimentsStore, { getExperimentsStore } from "@/store/experiments";
import { type AmplitudeExperiment, type FeatureFlagValue, type VariantValue } from "@/types";

export default class AmplitudeExperiments implements AmplitudeExperiment {
  client: ExperimentClient;
  store: ExperimentsStore;
  vm: Vue;

  constructor(apiKey: string, context: Context) {
    this.client = Experiment.initializeWithAmplitudeAnalytics(apiKey, {
      debug: context.$config.env !== "prod",
      automaticExposureTracking: false,
    });

    this.store = getExperimentsStore(context.store);

    const loggedInWatcher = (newValue: boolean) => {
      if (newValue === true) {
        this.identifyUser();
      }
    };

    // Until this app switches to Vue3, this is the way for plugins/external modules to make reactive watchers
    const vm = new Vue({
      // Using the auth $state object so the reactivity is maintained into the vue instance
      data: { $auth: context.$auth },
      watch: { "$data.$auth.loggedIn": loggedInWatcher },
    });
    this.vm = vm;
  }

  async identifyUser() {
    await this.client.fetch();
  }

  exposure(experimentName: string) {
    this.client.exposure(experimentName);
  }

  fetchVariant(variantName: string, defaultValue: VariantValue | Variant = "control") {
    const variant = this.client.variant(variantName, defaultValue);

    return variant;
  }

  fetchFeatureFlag(flagName: string, defaultValue: FeatureFlagValue | Variant = "off") {
    const variant = this.client.variant(flagName, defaultValue);

    return variant;
  }
}
